



























import { Component, Vue } from 'vue-property-decorator';
import { LoginCredentials } from '../interfaces/loginCredentials';
import { Action } from 'vuex-class';
import AppMessage from 'modules/core/models/appMessage';
import { ApiResponse } from '../interfaces/apiResponse';
import { ElForm } from 'element-ui/types/form';

@Component
export default class ResetPassword extends Vue {
  public form: any = {
    email: '',
  };
  public validationRules!: any;
  public loading: boolean = false;

  @Action('auth/resetPassword') private resetPassword!: (
    email: string,
  ) => Promise<boolean | undefined>;

  public created() {
    this.validationRules = {
      email: [
        { type: 'email', required: true, message: this.$t('forms.invalidEmail'), trigger: 'blur' },
      ],
    };
  }

  public onSubmit() {
    try {
      this.loading = true;

      (this.$refs.resetPasswordForm as ElForm).validate(async (valid: boolean) => {
        if (valid) {
          try {
            const success = await this.resetPassword(this.form);
            if (success) {
              AppMessage.show(
                this.$t('resetPassword.success'),
                'success',
              );
              this.$router.push('/login');
            } else {
              this.loading = false;
            }
          } catch (error) {
            console.warn('error', error);
            AppMessage.show(
              this.$t('resetPassword.failure'),
              'error',
            );
            this.loading = false;
          }
        } else {
          this.loading = false;
          return false;
        }
      });
    } catch (error) {
      this.loading = false;
      AppMessage.show(
        this.$t('resetPassword.failureMsg', { msg: error }),
        'error',
      );
      console.warn('Error during registration process: ' + error);
    }
  }
}
